/**
 * CUÁNDO MIRÉ CADA PANTALLA, GUARDADO EN ESTE TELÉFONO.
 *
 * Javier: «cuando hay memes nuevos o partidos nuevos poner un círculo en rojo
 * la cantidad de cosas nuevas que hayan para que los usuarios abran los
 * accesos rápidos».
 *
 * QUIÉN RECUERDA: EL TELÉFONO, y lo eligió Javier. El servidor no guarda por
 * persona cuándo abre cada pantalla; el teléfono manda «vi memes hasta tal
 * fecha» y el servidor cuenta lo posterior.
 *
 * LA CONSECUENCIA HAY QUE SABERLA: quien entre desde otro aparato va a ver el
 * globito otra vez con cosas que ya miró. Es el precio de no llevar ese rastro
 * en el servidor, y es el que se eligió a sabiendas.
 *
 * VA POR CUENTA Y NO SUELTO. Dos personas que comparten una tablet no
 * comparten lo que cada una miró: sin el id adentro de la llave, entrar con
 * otra cuenta heredaría las visitas de la anterior y el globito mentiría en
 * las dos.
 */
import { readStored, writeStored } from './storage';

/** Las cuatro pantallas que llevan globito. */
export type Pantalla = 'memes' | 'challenges' | 'posts' | 'tournaments';

export const PANTALLAS: readonly Pantalla[] = ['memes', 'challenges', 'posts', 'tournaments'];

/** La llave de esta persona y esta pantalla. Ver el comentario de arriba. */
function llave(userId: string, pantalla: Pantalla): string {
  return `tennisup.visto.${userId}.${pantalla}`;
}

/**
 * CUÁNDO MIRÓ ESA PANTALLA, o `undefined` si nunca en este teléfono.
 *
 * DEVUELVE LA CADENA TAL CUAL y no un `Date`: lo que hace falta es mandarla en
 * la consulta, y convertirla a `Date` para volver a convertirla a texto es dar
 * una vuelta en la que se pierde precisión y se gana una zona horaria que
 * nadie pidió. El servidor ya trata lo ilegible como «nunca miró».
 */
export function cuándoMiró(userId: string, pantalla: Pantalla): string | undefined {
  const guardado = readStored(llave(userId, pantalla));
  return guardado === null || guardado === '' ? undefined : guardado;
}

/** Las cuatro juntas, como las pide el endpoint de novedades. */
export function últimasVisitas(userId: string): Partial<Record<Pantalla, string>> {
  const salida: Partial<Record<Pantalla, string>> = {};
  for (const pantalla of PANTALLAS) {
    const cuándo = cuándoMiró(userId, pantalla);
    if (cuándo !== undefined) salida[pantalla] = cuándo;
  }
  return salida;
}

/**
 * ACABA DE MIRARLA: se anota AHORA.
 *
 * SE GUARDA EL INSTANTE DE ABRIR Y NO EL DE CERRAR. Si se guardara al salir,
 * lo publicado mientras la persona miraba quedaría contado como visto sin que
 * lo haya visto — y al revés, guardando al abrir, algo que llegó durante la
 * visita aparece como novedad la próxima vez. De los dos errores posibles,
 * este es el que no esconde nada.
 */
export function anotarVisita(userId: string, pantalla: Pantalla, ahora = new Date()): void {
  writeStored(llave(userId, pantalla), ahora.toISOString());
}
